<!-- =========================================================================================
    File Name: Profile.vue
    Description: User's profile editing page
========================================================================================== -->

<template>
  <div class="profile">
      <div class="flex flex-wrap justify-between items-start mb-8">
        <h2 class="font-light text-lg my-3">EDITER VOTRE PROFIL</h2>
      </div>

      <!-- profile form -->
      <user-profile-form />

      <!-- password form -->
      <user-password-form />

<!--      &lt;!&ndash;  ASIDE &ndash;&gt;-->
<!--      <template slot="aside" v-if="!$acl.check('admin')">-->
<!--        &lt;!&ndash; payment form &ndash;&gt;-->
<!--        <h4 class="mt-5 mb-8">&nbsp;</h4>-->
<!--        <user-payment-form />-->
<!--        -->
<!--      </template>-->
      <template slot="aside" v-if="$acl.check('admin')">
        <div class="flex flex-wrap justify-between items-center mb-8">
          <vs-button disabled type="gradient" icon-pack="feather" icon="icon-list" color="light">Historique des paiements</vs-button>
        </div>

        <!-- payment form -->
        <p>En tant qu'administrateur, vous n'avez pas de mode de paiement.</p>

      </template>

  </div>
</template>

<script>
// @ is an alias to /src
import ColumnLayout from '@/layouts/columns/ColumnLayout.vue'
import UserProfileForm from '@/layouts/forms/UserProfileForm'
import UserPasswordForm from '@/layouts/forms/UserPasswordForm'
import UserPaymentForm from '@/layouts/forms/UserPaymentForm'

export default {
  name: 'Profile',
  components: {
    UserProfileForm,
    UserPasswordForm,
    UserPaymentForm,
    ColumnLayout
  }
}
</script>


<style language="scss">


</style>
